module.exports = __webpack_public_path__ + "media/images/sp/specials/common/recommend_color_dress-a472354a41fecbcb2ce3ec0c9bc73dfa.jpg";